import { apiPost } from '../client';
import { LONG_TIMEOUT_MS } from '../../config/env';
import type {
  PosPaymentResponse,
  VirtualPosInitRequest,
  VirtualPosInitResponse,
  VirtualPosTransactionsRequest,
  VirtualPosTransactionsResponse,
} from '../types/pos';
import type { PaymentRequest } from '../types/payment';

/** Confirmed via curl against the real API — request is just {sessionHeader, amount}. */
export function initVirtualPos(body: VirtualPosInitRequest): Promise<VirtualPosInitResponse> {
  return apiPost<VirtualPosInitRequest, VirtualPosInitResponse>('InitVirtualPos', body, {
    timeoutMs: LONG_TIMEOUT_MS,
  });
}

/** Shared MakePayment route — see api/types/pos.ts header. The standalone virtual-POS
 *  screen passes `paymentChannel: 1`. */
export function makePosPayment(body: PaymentRequest): Promise<PosPaymentResponse> {
  return apiPost<PaymentRequest, PosPaymentResponse>('MakePayment', body, { timeoutMs: LONG_TIMEOUT_MS });
}

/** Sanal POS işlem listesi (`VirtualPos/ListTransactions`). Tarihler dd.MM.yyyy. */
export function listVirtualPosTransactions(
  body: VirtualPosTransactionsRequest
): Promise<VirtualPosTransactionsResponse> {
  return apiPost<VirtualPosTransactionsRequest, VirtualPosTransactionsResponse>(
    'VirtualPos/ListTransactions',
    body
  );
}
